var t={"&":"&amp;",">":"&gt;","<":"&lt;",'"':"&quot;","'":"&#39;","`":"&#96;"},e=new RegExp(Object.keys(t).join("|"),"g");function n(n){return void 0===n&&(n=""),String(n).replace(e,(function(e){return t[e]}))}export{n as default};
